import { useCallback, useEffect, useState } from 'react'

import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'

export const useUpdateEmptyStateViewed = ({ contentKey }) => {
  const { data } = useGetUserQuery()
  const { activation_data: activationData } = data
  const emptyStateViewed = activationData?.empty_state_viewed || {}
  const [update, { isUninitialized }] = useUpdateUserActivationDataMutation()
  const userViewed = emptyStateViewed[contentKey]
  const [hasViewed, setHasViewed] = useState(userViewed)
  const [currentKey, setCurrentKey] = useState(contentKey)

  useEffect(() => {
    if (currentKey === contentKey) return
    setCurrentKey(contentKey)
  }, [contentKey, currentKey, setCurrentKey])

  useEffect(() => {
    if (hasViewed === userViewed) return
    setHasViewed(userViewed)
  }, [hasViewed, setHasViewed, userViewed])

  const updateFn = useCallback(() => {
    update((oldActivationData) => ({
      ...oldActivationData,
      empty_state_viewed: {
        ...oldActivationData?.empty_state_viewed,
        [currentKey]: true
      }
    }))
  }, [currentKey, update])

  return ([
    hasViewed,
    updateFn,
    isUninitialized
  ])
}
